export enum GeneralEvents {
  MOVE_PAGE_FROM_SIDEBAR = "general_move_page_from_sidebar",
  BUTTON_CLICK = "general_button_click",
  FORM_SUBMIT = "general_form_submit",
  MODAL_OPEN = "general_modal_open",
  MODAL_CLOSE = "general_modal_close",
  SEARCH = "general_search",
  FILTER_APPLIED = "general_filter_applied",
  EXPORT_DATA = "general_export_data",
}